import axios from 'axios'

import { baseUrlLinksApi } from 'src/api/links'
import type { MarketingEvent } from 'src/models/Marketing'

const PATH = '/fans' as const

export const createFanItem = (
  orgId: string,
  linkId: string,
  marketingEvent: Partial<MarketingEvent>,
  eventType: string,
  recaptchaToken: string,
  platform?: string,
  email?: string,
  phone?: string
) =>
  axios.post<string>(`${baseUrlLinksApi}${PATH}/${orgId}/${linkId}`,
    { marketingEvent, eventType, platform, email, phone, recaptchaToken })
    .then(result => result.data)
